import { HttpClient } from '@angular/common/http';
import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, catchError, distinctUntilChanged, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from './operatori.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import Swal from 'sweetalert2';
import { EditOperatorComponent } from './edit-operator/edit-operator.component';
import { PermissionsService } from '../../../services/permissions.service';
import { UpdateFunctieOperatorComponent } from './update-functie-operator/update-functie-operator.component'
import { UpdateFunctiiMultipleOperatorComponent } from './update-functii-multiple-operator/update-functii-multiple-operator.component'
import { FormControl, FormGroup } from '@angular/forms';
import { Generic, GenericUser } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { AlocareDirectieComponent } from './alocare-directie/alocare-directie.component';
// import { UserProfileService } from 'src/app/components/user-profile/user-profile.service';
// import { ActivityScheduleService } from 'src/app/components/activity-schedule/services/activity-schedule.service';
import { Router } from '@angular/router';
import { UserProfileService } from 'src/app/components/user-profile/user-profile.service';

@Component({
    selector: 'app-operatori',
    templateUrl: './operatori.component.html',
    styleUrls: ['./operatori.component.scss'],
})
export class OperatoriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    dgaspc_id = environment.interop.dgaspcId;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    functiiMap: { [key: number]: string } = {};
    names!: GenericUser[];
    functii!: any[];

    private destroy$ = new Subject<void>();

    directii: Generic[] = [];
    filteredDirectii: Generic[] = [];
    directiiControl = new FormControl();

    compartimente: Generic[] = [];
    filteredCompartimente: Generic[] = [];
    compartimenteControl = new FormControl();

    filteredDirectiiActive: Generic[] = [];
    directiiActiveControl = new FormControl();

    compartimenteActive: Generic[] = [];
    filteredCompartimenteActive: Generic[] = [];
    compartimenteActiveControl = new FormControl();

    // Track expanded rows for showing all functions
    expandedFunctii: Set<number> = new Set();
    expandedAccess: Set<number> = new Set();

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    defaultNameParameter: { name: string; id_user: string } = {
        name: 'Toate',
        id_user: '-1',
    };

    dtLink =
        environment.interop.basePath +
        environment.interop.indoc.nomenclatoare.registratura.operatori.listDT

    //Form Initial Values

    searchParamsForm!: FormGroup;

    initialFormValues = {
        name: '',
        functie: '-1',
        signature: '-1',
        directie: '-1',
        compartiment: '-1',
        active_directie: '-1',
        active_compartiment: '-1',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            name: new FormControl(''),
            functie: new FormControl('-1'),
            signature: new FormControl('-1'),
            directie: new FormControl('-1'),
            compartiment: new FormControl('-1'),
            active_directie: new FormControl('-1'),
            active_compartiment: new FormControl('-1'),
        });
    }


    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private operatoriService: OperatoriService,
        public permissionsService: PermissionsService,
        private commonService: CommonService,
        private userProfileService: UserProfileService,
        // private activityScheduleService: ActivityScheduleService,
        private router: Router,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.getFunctii();
        this.buildSearchParamsForm();
        this.loadFilteringElements();

        this.renderFieldsSearch();
    }


    toggleCard() {
        this.showCard = !this.showCard;
    }

    loadFilteringElements() {
        this.loadDirectii();
        // this.loadCompartimenteActive(this.dgaspc_id);
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.resetFieldsSearch();

        this.rerenderDT();
        this.showCard = true;
    }

    resetFieldsSearch() {
        // this.loadCompartimenteActive(this.dgaspc_id);

        this.filteredDirectii = this.directii;
        this.directiiControl.setValue(null);

        this.compartimente = [];
        this.filteredCompartimente = [];
        this.compartimenteControl.setValue(null);

        this.compartimenteActive = [];
        this.filteredCompartimenteActive = [];
        this.compartimenteActiveControl.setValue(null);

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch()
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT();
    }

    getFunctii() {
        this.commonService.getFunctii().subscribe((data) => {
            this.functii = [this.defaultParameter, ...data];
            data.forEach((item) => {
                this.functiiMap[item.id] = item.name;
            });
        });
    }

    // Helper methods pentru switch_access
    getActiveAccess(switchAccess: any[]): any | null {
        return switchAccess?.find(access => access.active === true) || null;
    }

    getInactiveAccess(switchAccess: any[]): any[] {
        return switchAccess?.filter(access => access.active === false) || [];
    }

    // Helper method to get active function for a user
    getActiveFunctie(functii: any[]): any | null {
        return functii?.find(f => f.is_active === true) || null;
    }

    // Helper method to get inactive functions for a user
    getInactiveFunctii(functii: any[]): any[] {
        return functii?.filter(f => f.is_active === false) || [];
    }

    // Toggle expanded state for a row
    toggleFunctiiExpansion(userId: number): void {
        if (this.expandedFunctii.has(userId)) {
            this.expandedFunctii.delete(userId);
        } else {
            this.expandedFunctii.add(userId);
        }
    }

    toggleAccessExpansion(userId: number): void {
        if (this.expandedAccess.has(userId)) {
            this.expandedAccess.delete(userId);
        } else {
            this.expandedAccess.add(userId);
        }
    }

    // Check if row is expanded
    isRowFunctiiExpanded(userId: number): boolean {
        return this.expandedFunctii.has(userId);
    }

    isRowAccessExpanded(userId: number): boolean {
        return this.expandedAccess.has(userId);
    }

    renderFieldsSearch() {
        this.directiiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectii = this.directii;
                    return of(this.directii);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimente = this.compartimente;
                    return of(this.compartimente);
                }
                return this.filterCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.directiiActiveControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectiiActive = this.directii;
                    return of(this.directii);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiActive = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteActiveControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimenteActive = this.compartimenteActive;
                    return of(this.compartimenteActive);
                }
                return this.filterCompartimenteActive(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimenteActive = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadDirectii() {
        this.isFilterLoading = true;
        this.commonService
            .getDirectiiActive()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isFilterLoading = false)
            )
            .subscribe({
                next: (data) => {
                    this.directii = [...data];
                    this.filteredDirectii = [...this.directii];
                    this.filteredDirectiiActive = [...this.directii];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredDirectii = [];
                    this.filteredDirectiiActive = [];
                },
            });
    }

    onDirectieClosed() {
        const selectedValue = this.directiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectii.some(directie =>
                directie.id === this.searchParamsForm.get('directie')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControl.setValue(null);
                this.filteredDirectii = this.directii;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectieChange(directieId: number): void {
        this.searchParamsForm.controls['compartiment'].patchValue('-1');

        if (directieId > 0) {
            this.loadCompartimente(directieId);
        } else {
            this.compartimente = [];
            this.filteredCompartimente = [];
        }
    }

    onDirectieActiveClosed() {
        const selectedValue = this.directiiActiveControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectiiActive.some(directie =>
                directie.id === this.searchParamsForm.get('active_directie')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiActiveControl.setValue(null);
                this.filteredDirectiiActive = this.directii;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectieActiveChange(directieId: number): void {
        this.searchParamsForm.controls['active_compartiment'].patchValue('-1');

        if (directieId > 0) {
            this.loadCompartimenteActive(directieId);
        } else {
            this.compartimenteActive = [];
            this.filteredCompartimenteActive = [];
        }
    }

    loadCompartimente(directieId?: number) {
        this.isFilterLoading = true;

        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectieId(directieId)
            : this.commonService.getCompartimenteActive();

        compartimenteObservable$
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (data) => {
                    this.compartimente = [...data];
                    this.filteredCompartimente = [...this.compartimente];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredCompartimente = [];
                },
            });
    }

    onCompartimentClosed() {
        const selectedValue = this.compartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimente.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('compartiment')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControl.setValue(null);
                this.filteredCompartimente = this.compartimente;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;

        let compartimenteObservable$ = directieId
            ? this.commonService.getCompartimenteByDirectieId(directieId)
            : this.commonService.getCompartimenteActive();

        compartimenteObservable$
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isFilterLoading = false })
            ).subscribe({
                next: (data) => {
                    this.compartimenteActive = [...data];
                    this.filteredCompartimenteActive = [...this.compartimenteActive];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredCompartimenteActive = [];
                },
            });
    }

    onCompartimentActiveClosed() {
        const selectedValue = this.compartimenteActiveControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimenteActive.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('active_compartiment')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteActiveControl.setValue(null);
                this.filteredCompartimenteActive = this.compartimenteActive;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directii.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterCompartimente(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimente.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterCompartimenteActive(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.compartimenteActive.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            searching: false,
            serverSide: true,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.filters = this.searchParamsForm.value;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '150px', targets: 2 },
                { width: '300px', targets: 3 },
                { width: '400px', targets: 4 },
            ],
            columns: [
                {
                    title: 'ID',
                    data: 'id_user',
                },
                {
                    title: 'Nume',
                    data: 'name',
                },
                {
                    title: 'Funcție',
                    data: 'functii',
                    render: (data: any[], type: string, row: any) => {
                        const activeFunctie = this.getActiveFunctie(data);
                        const inactiveFunctii = this.getInactiveFunctii(data);
                        const isExpanded = this.isRowFunctiiExpanded(row.id_user);

                        let html = '';

                        if (activeFunctie) {
                            html += `<div class="active-function"><strong>${activeFunctie.functie_name}</strong></div>`;
                        } else {
                            html += '<div class="no-active-function">N/A</div>';
                        }

                        // Show "More" button if there are inactive functions
                        if (inactiveFunctii.length > 0) {
                            html += `<button class="btn btn-sm btn-link toggle-functions p-0" data-userid="${row.id_user}">
                                       <i class="fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}"></i> 
                                       ${isExpanded ? 'Less' : 'More'} (${inactiveFunctii.length})
                                     </button>`;
                        }

                        // Show inactive functions if expanded
                        if (isExpanded && inactiveFunctii.length > 0) {
                            html += '<div class="inactive-functions mt-2">';
                            inactiveFunctii.forEach(functie => {
                                html += `<div class="inactive-function text-muted small">
                                           <i class="fa fa-circle-o me-1"></i>${functie.functie_name}
                                         </div>`;
                            });
                            html += '</div>';
                        }

                        return html;
                    },
                },
                {
                    title: 'Instituție / Compartiment (Organigramă)',
                    data: null,
                    orderable: false,
                    render: (data: any, type: string, row: any) => {
                        const institutie = row.denumire_sesizare_departament || 'N/A';
                        const compartiment = row.denumire_sesizare_compartiment || 'N/A';
                        return `
                            <div class="institution-info">
                                <div class="institution-name"><strong>${institutie}</strong></div>
                                <div class="compartment-name text-muted small">${compartiment}</div>
                            </div>
                        `;
                    },
                },
                {
                    title: 'Acces',
                    data: 'switch_access',
                    render: (data: any[], type: string, row: any) => {
                        const activeAccess = this.getActiveAccess(data);
                        const inactiveAccess = this.getInactiveAccess(data);
                        const isExpanded = this.isRowAccessExpanded(row.id_user);

                        let html = '';

                        // Afișează accesul activ
                        if (activeAccess) {
                            html += `<div class="active-access">
                        <div><strong>${activeAccess.denumire_directie}</strong></div>
                        <div class="text-muted small">${activeAccess.denumire_compartiment}</div>
                     </div>`;
                        } else {
                            html += '<div class="no-active-access">N/A</div>';
                        }

                        // Buton "More" dacă sunt accesuri inactive
                        if (inactiveAccess.length > 0) {
                            html += `<button class="btn btn-sm btn-link toggle-access p-0" data-userid="${row.id_user}">
                        <i class="fa ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}"></i> 
                        ${isExpanded ? 'Less' : 'More'} (${inactiveAccess.length})
                     </button>`;
                        }

                        // Afișează accesurile inactive când e expandat
                        if (isExpanded && inactiveAccess.length > 0) {
                            html += '<div class="inactive-access mt-2">';
                            inactiveAccess.forEach(access => {
                                html += `<div class="inactive-access-item text-muted small">
                            <i class="fa fa-circle-o me-1"></i>
                            <div><strong>${access.denumire_directie}</strong></div>
                            <div>${access.denumire_compartiment}</div>
                         </div>`;
                            });
                            html += '</div>';
                        }

                        return html;
                    },
                },
                // {
                //     title: 'Program Disponibilitate',
                //     data: 'availability_program',
                //     orderable: false,
                //     render: (data: any, type: string, row: any) => {
                //         const hasProgram = data?.has_program || false;
                //         const totalHours = data?.total_weekly_hours || 0;
                //         const activeDays = data?.active_days || 0;

                //         if (hasProgram) {
                //             return `
                //                 <div class="availability-status has-program">
                //                     <i class="fa fa-calendar-check text-success me-1"></i>
                //                     <span class="text-success small font-weight-bold">Activ</span>
                //                     <div class="program-details text-muted small">
                //                         ${activeDays} zile • ${totalHours}h/săptămână
                //                     </div>
                //                     <button class="btn btn-xs btn-outline-primary mt-1 view-program" 
                //                             data-userid="${row.id_user}" 
                //                             title="Vizualizează programul">
                //                         <i class="fa fa-eye"></i> Vezi program
                //                     </button>
                //                 </div>
                //             `;
                //         } else {
                //             return `
                //                 <div class="availability-status no-program">
                //                     <i class="fa fa-calendar-times text-warning me-1"></i>
                //                     <span class="text-warning small">Lipsă program</span>
                //                     <button class="btn btn-xs btn-outline-info mt-1 setup-program" 
                //                             data-userid="${row.id_user}" 
                //                             title="Configurează program">
                //                         <i class="fa fa-plus"></i> Adaugă program
                //                     </button>
                //                 </div>
                //             `;
                //         }
                //     },
                // },
                {
                    title: 'Semnătură',
                    data: 'signature',
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: string, row: any) => {
                        const hasSignature = data?.has_signature || false;
                        const signatureType = data?.type || 'none';

                        if (hasSignature) {
                            const icon = signatureType === 'canvas' ? 'gesture' : 'image';
                            const iconClass = signatureType === 'canvas' ? 'text-primary' : 'text-success';
                            return `
                                <div class="signature-status has-signature">
                                    <i class="fa fa-${icon} ${iconClass} me-1" title="${signatureType === 'canvas' ? 'Canvas signature' : 'Image signature'}"></i>
                                    <span class="text-success small">Active</span>
                                    <button class="btn btn-xs btn-outline-info ms-1 view-signature" 
                                            data-userid="${row.id_user}" 
                                            title="View signature">
                                        <i class="fa fa-eye"></i>
                                    </button>
                                </div>
                            `;
                        } else {
                            return `
                                <div class="signature-status no-signature">
                                    <i class="fa fa-times-circle text-muted me-1" title="No signature"></i>
                                    <span class="text-muted small">None</span>
                                </div>
                            `;
                        }
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (row: any) => {
                        return (
                            `
                            <div class="d-flex align-center justify-content-left">
							<button type="button" class="action-btn allocate me-1" title="Alocare direcție">
							    <img class="btn-img" src="/assets/icons/wrench.svg" alt="alocare-directie"/>
							</button> 
							<button type="button" class="action-btn edit me-1" title="Editare">
							    <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
							</button> 
                            <button class="action-btn action-danger me-1" title="Gestionare Funcții Multiple (Sistem Nou)">
                				<img class="btn-img" src="/assets/icons/work_outline.svg" alt="multiple-functions"/>
              				</button>
                            </div>
						    `
                            // <button class="action-btn signatures me-1" title="Actualizare Funcție (Sistem Vechi)" disabled>
                            // 	<img class="btn-img" src="/assets/icons/simple-signature-contract.svg" alt="signatures"/>
                            // </button>
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const allocateIcon = lastTd?.querySelector('.allocate') as HTMLElement;
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;

                const signaturesIcon = lastTd?.querySelector(
                    '.signatures'
                ) as HTMLElement;

                const multipleFunctionsIcon = lastTd?.querySelector(
                    '.action-danger'
                ) as HTMLElement;

                // Handle toggle functions button
                const functiiTd = (row as HTMLElement).querySelector('td:nth-child(3)');
                const toggleFunctiiButton = functiiTd?.querySelector('.toggle-functions') as HTMLElement;

                if (toggleFunctiiButton) {
                    toggleFunctiiButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        const userId = parseInt(toggleFunctiiButton.getAttribute('data-userid') || '0');
                        this.toggleFunctiiExpansion(userId);
                        this.rerenderDT(false);
                    });
                }

                // Handle toggle functions button
                const accesTd = (row as HTMLElement).querySelector('td:nth-child(5)');
                const toggleAccesButton = accesTd?.querySelector('.toggle-access') as HTMLElement;

                if (toggleAccesButton) {
                    toggleAccesButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        const userId = parseInt(toggleAccesButton.getAttribute('data-userid') || '0');
                        this.toggleAccessExpansion(userId);
                        this.rerenderDT(false);
                    });
                }

                if (allocateIcon) {
                    if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.allocate')) {
                        allocateIcon.style.display = 'none';
                    }
                    allocateIcon.addEventListener('click', () => {
                        this.alocareDirectie({ id_user: data.id_user });
                    });
                }

                if (editIcon) {
                    if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.update')) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (signaturesIcon) {
                    if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.update-functie')) {
                        signaturesIcon.style.display = 'none';
                    }
                    signaturesIcon.addEventListener('click', () => {
                        this.openUpdateFunctieOperator(data);
                    });
                }

                if (multipleFunctionsIcon) {
                    if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.update-functie')) {
                        multipleFunctionsIcon.style.display = 'none';
                    }
                    multipleFunctionsIcon.addEventListener('click', () => {
                        this.openUpdateFunctiiMultipleOperator(data);
                    });
                }

                // Handle view signature button
                const signatureTd = (row as HTMLElement).querySelector('td:nth-child(6)'); // Signature column
                const viewSignatureButton = signatureTd?.querySelector('.view-signature') as HTMLElement;

                if (viewSignatureButton) {
                    if (!this.permissionsService.hasPermission('indoc-module.settings.operatori.view-signature')) {
                        viewSignatureButton.style.display = 'none';
                    }

                    viewSignatureButton.addEventListener('click', (e) => {
                        e.preventDefault();
                        const userId = parseInt(viewSignatureButton.getAttribute('data-userid') || '0');
                        this.viewUserSignature(userId, data);
                    });
                }

                // Handle availability program buttons
                // const availabilityTd = (row as HTMLElement).querySelector('td:nth-child(5)'); // Availability program column
                // const viewProgramButton = availabilityTd?.querySelector('.view-program') as HTMLElement;
                // const setupProgramButton = availabilityTd?.querySelector('.setup-program') as HTMLElement;

                // if (viewProgramButton) {
                //     viewProgramButton.addEventListener('click', (e) => {
                //         e.preventDefault();
                //         const userId = parseInt(viewProgramButton.getAttribute('data-userid') || '0');
                //         this.viewUserAvailabilityProgram(userId, data);
                //     });
                // }

                // if (setupProgramButton) {
                //     setupProgramButton.addEventListener('click', (e) => {
                //         e.preventDefault();
                //         const userId = parseInt(setupProgramButton.getAttribute('data-userid') || '0');
                //         this.setupUserAvailabilityProgram(userId, data);
                //     });
                // }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    alocareDirectie(data: { id_user: number }) {
        const dialogRef = this.dialog.open(AlocareDirectieComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data,
        });
        // dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
        //     if (success) {
        //         this.rerenderDT();
        //     }
        // });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditOperatorComponent, {
            minHeight: '80vh',
            maxHeight: '80vh',
            minWidth: '50vw',
            maxWidth: '80vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openUpdateFunctieOperator(data: any) {
        const dialogRef = this.dialog.open(UpdateFunctieOperatorComponent, {
            maxHeight: '40vh',
            minWidth: '50vw',
            maxWidth: '90vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
            if (success) {
                this.isLoading = true;
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openUpdateFunctiiMultipleOperator(data: any) {
        const dialogRef = this.dialog.open(UpdateFunctiiMultipleOperatorComponent, {
            minHeight: '70vh',
            maxHeight: '90vh',
            minWidth: '60vw',
            maxWidth: '90vw',
            autoFocus: false,
            data,
        });

        dialogRef.afterClosed().subscribe((result: { success: boolean }) => {
            this.rerenderDT();
            if (result?.success) {
                this.isLoading = true;
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Funcțiile operatorului au fost actualizate cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    viewUserSignature(userId: number, userData: any): void {
        if (!userId) {
            return;
        }

        this.userProfileService.getSignatureByUserId(userId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    if (response.success && response.data) {
                        const signature = response.data;
                        let imageUrl = '';

                        if (signature.type === 'image' && signature.url) {
                            imageUrl = signature.url;
                        } else if (signature.type === 'canvas' && signature.content) {
                            imageUrl = signature.content;
                        }

                        Swal.fire({
                            title: `${userData.name} - Signature`,
                            html: `
                                <div style="text-align: center;">
                                    <div style="margin-bottom: 15px;">
                                        <strong>Type:</strong> ${signature.type === 'canvas' ? 'Canvas Drawn' : 'Uploaded Image'}<br>
                                        <strong>Created:</strong> ${new Date(signature.created_at || '').toLocaleDateString()}<br>
                                        ${signature.file_size ? `<strong>Size:</strong> ${signature.file_size}<br>` : ''}
                                    </div>
                                    ${imageUrl ? `<img src="${imageUrl}" alt="User Signature" style="max-width: 300px; max-height: 200px; border: 1px solid #ddd; border-radius: 4px;">` : '<p>No signature image available</p>'}
                                </div>
                            `,
                            width: 500,
                            showCloseButton: true,
                            confirmButtonText: 'Close',
                            confirmButtonColor: '#3085d6'
                        });
                    } else {
                        Swal.fire({
                            title: 'No Signature',
                            text: `${userData.name} does not have a signature.`,
                            icon: 'info',
                            confirmButtonText: 'Close'
                        });
                    }
                },
                error: (error) => {
                    console.error('Error fetching user signature:', error);
                    Swal.fire({
                        title: 'Error',
                        text: 'Failed to load user signature. Please try again.',
                        icon: 'error',
                        confirmButtonText: 'Close'
                    });
                }
            });
    }

    // ========================================
    // AVAILABILITY PROGRAM MANAGEMENT
    // ========================================

    /**
     * View user's availability program in a dialog
     */
    // viewUserAvailabilityProgram(userId: number, userData: any): void {
    //     console.log('Viewing availability program for user:', userId, userData);

    //     Swal.fire({
    //         title: 'Se încarcă programul...',
    //         allowOutsideClick: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         }
    //     });

    //     this.activityScheduleService.getUserAvailability(userId).subscribe({
    //         next: (availability: any) => {
    //             console.log('User availability data:', availability);

    //             // Process availability data
    //             const weeklyData = this.processAvailabilityData(availability);
    //             const hasDateRange = availability.date_range && availability.date_range.is_active;

    //             const htmlContent = this.buildAvailabilityHTML(weeklyData, availability.date_range, userData);

    //             Swal.fire({
    //                 title: `Program Disponibilitate - ${userData.name}`,
    //                 html: htmlContent,
    //                 width: 800,
    //                 showCloseButton: true,
    //                 showCancelButton: true,
    //                 confirmButtonText: '<i class="fa fa-edit"></i> Editează program',
    //                 confirmButtonColor: '#007bff',
    //                 cancelButtonText: 'Închide',
    //                 cancelButtonColor: '#6c757d',
    //                 customClass: {
    //                     popup: 'availability-program-dialog'
    //                 }
    //             }).then((result) => {
    //                 if (result.isConfirmed) {
    //                     // Navigate to availability management for this user
    //                     this.setupUserAvailabilityProgram(userId, userData);
    //                 }
    //             });
    //         },
    //         error: (error) => {
    //             console.error('Error loading availability program:', error);
    //             Swal.fire({
    //                 title: 'Eroare',
    //                 text: 'Nu s-a putut încărca programul de disponibilitate.',
    //                 icon: 'error',
    //                 confirmButtonText: 'Închide'
    //             });
    //         }
    //     });
    // }

    /**
     * Setup/Edit user's availability program - navigate to availability management
     */
    setupUserAvailabilityProgram(userId: number, userData: any): void {
        console.log('Setting up availability program for user:', userId, userData);

        // Show confirmation dialog
        Swal.fire({
            title: 'Configurare Program',
            html: `
                <div class="setup-program-dialog">
                    <p>Vei fi redirecționat către pagina de configurare a programului de disponibilitate pentru:</p>
                    <div class="user-info">
                        <strong>${userData.name}</strong><br>
                        <small class="text-muted">ID: ${userId}</small>
                    </div>
                </div>
            `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: '<i class="fa fa-arrow-right"></i> Continuă',
            confirmButtonColor: '#007bff',
            cancelButtonText: 'Anulează',
            cancelButtonColor: '#6c757d'
        }).then((result) => {
            if (result.isConfirmed) {
                // Navigate to activity schedule availability management
                // Note: This assumes the route exists - you may need to adjust the route path
                this.router.navigate(['/activity-schedule/availability'], {
                    queryParams: { userId: userId, userName: userData.name }
                });
            }
        });
    }

    /**
     * Process availability data for display
     */
    private processAvailabilityData(availability: any): any[] {
        const dayNames = ['Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă', 'Duminică'];
        const weeklyData = [];

        for (let dayIndex = 1; dayIndex <= 7; dayIndex++) {
            const daySlots = availability[dayIndex] || [];
            const dayName = dayNames[dayIndex - 1];

            if (daySlots.length > 0) {
                const totalMinutes = daySlots.reduce((total: number, slot: any) => {
                    const start = this.timeToMinutes(slot.start_time);
                    const end = this.timeToMinutes(slot.end_time);
                    return total + (end - start);
                }, 0);

                weeklyData.push({
                    day: dayName,
                    slots: daySlots,
                    totalHours: Math.round((totalMinutes / 60) * 10) / 10,
                    isActive: true
                });
            } else {
                weeklyData.push({
                    day: dayName,
                    slots: [],
                    totalHours: 0,
                    isActive: false
                });
            }
        }

        return weeklyData;
    }

    /**
     * Convert time string to minutes
     */
    private timeToMinutes(time: string): number {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    }

    /**
     * Build HTML content for availability dialog
     */
    private buildAvailabilityHTML(weeklyData: any[], dateRange: any, userData: any): string {
        let html = `
            <div class="availability-overview">
        `;

        // Date range information
        if (dateRange && dateRange.is_active) {
            html += `
                <div class="date-range-info mb-3 p-3" style="background-color: #e3f2fd; border-radius: 8px; border-left: 4px solid #2196f3;">
                    <h6 style="margin: 0 0 8px 0; color: #1976d2;">
                        <i class="fa fa-calendar-alt"></i> Perioadă Activă
                    </h6>
                    <div style="font-size: 14px;">
                        <strong>De la:</strong> ${new Date(dateRange.availability_start_date).toLocaleDateString('ro-RO')}<br>
                        <strong>Până la:</strong> ${new Date(dateRange.availability_end_date).toLocaleDateString('ro-RO')}
                    </div>
                </div>
            `;
        }

        // Weekly schedule
        html += `
            <div class="weekly-schedule">
                <h6 style="margin-bottom: 16px; color: #333;">
                    <i class="fa fa-clock"></i> Program Săptămânal
                </h6>
                <div class="days-container">
        `;

        weeklyData.forEach(dayData => {
            const statusClass = dayData.isActive ? 'day-active' : 'day-inactive';
            const statusIcon = dayData.isActive ? 'fa-check-circle text-success' : 'fa-times-circle text-muted';

            html += `
                <div class="day-row ${statusClass}" style="display: flex; align-items: center; margin-bottom: 12px; padding: 12px; border-radius: 8px; background-color: ${dayData.isActive ? '#f8f9fa' : '#ffffff'}; border: 1px solid ${dayData.isActive ? '#28a745' : '#e0e0e0'};">
                    <div class="day-name" style="width: 100px; font-weight: bold;">
                        <i class="fa ${statusIcon}" style="margin-right: 8px;"></i>
                        ${dayData.day}
                    </div>
                    <div class="day-schedule" style="flex: 1;">
            `;

            if (dayData.isActive && dayData.slots.length > 0) {
                dayData.slots.forEach((slot: any, index: number) => {
                    html += `
                        <span class="time-slot" style="display: inline-block; margin-right: 12px; padding: 4px 8px; background-color: #007bff; color: white; border-radius: 4px; font-size: 12px;">
                            ${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}
                        </span>
                    `;
                });
                html += `
                    <div class="day-total" style="font-size: 12px; color: #666; margin-top: 4px;">
                        Total: ${dayData.totalHours}h
                    </div>
                `;
            } else {
                html += `<span class="no-schedule" style="color: #999; font-style: italic;">Zi indisponibilă</span>`;
            }

            html += `
                    </div>
                </div>
            `;
        });

        // Calculate totals
        const totalActiveDays = weeklyData.filter(d => d.isActive).length;
        const totalWeeklyHours = weeklyData.reduce((total, d) => total + d.totalHours, 0);

        html += `
                </div>
            </div>
            
            <div class="program-summary mt-3 p-3" style="background-color: #f8f9fa; border-radius: 8px;">
                <h6 style="margin: 0 0 8px 0; color: #333;">
                    <i class="fa fa-chart-bar"></i> Sumar
                </h6>
                <div class="summary-stats" style="display: flex; gap: 24px;">
                    <div class="stat">
                        <strong>${totalActiveDays}</strong> zile active
                    </div>
                    <div class="stat">
                        <strong>${totalWeeklyHours}h</strong> total săptămânal
                    </div>
                    <div class="stat">
                        <strong>${Math.round(totalWeeklyHours / Math.max(totalActiveDays, 1) * 10) / 10}h</strong> medie/zi
                    </div>
                </div>
            </div>
        </div>
        `;

        return html;
    }
}